const NotFound = () => {
  return (
    <div>
      <h2>404 - Página no encontrada</h2>
      <p>La página que estás buscando no existe.</p>
    </div>
  );
};

export default NotFound;